import {
    Component,
    effect,
    inject,
    input,
    InputSignal,
    computed,
    Signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IqStatusLibraryStateService } from '../state';
import { Info, InfoSchema } from '../models';
import { IqBuilderLabelComponent } from '@dat/iq-style-processor';


@Component({
    selector: 'iq-status-library-card',
    standalone: true,
    imports: [CommonModule, IqBuilderLabelComponent],
    templateUrl: './iq-status-library-card.component.html',
    styleUrl: './iq-status-library-card.component.scss',
})
export class IqStatusLibraryCardComponent {
    private _state: IqStatusLibraryStateService = inject(
        IqStatusLibraryStateService,
    );

    projectKey: InputSignal<string> = input<string>();
    id: InputSignal<string> = input<string>();
    testId: InputSignal<string> = input<string>();

    currentTestId: Signal<string> = computed(() => {
        return this.testId()?.length ? this.testId() : this.id();
    });
    info: Info = {};
    projectIcon: string = '';

    bodyKeys: string[] = [
        'environment',
        'team',
        'domain',
        'e2eProject',
        'leveragesNonCritical',
        'componetized',
        'stability',
        'abstraction',
        'modularity',
        'testCoverage',
        'uiUxCoverage',
        'e2eCoverage',
    ];

    constructor() {
        effect(async () => {
            const projectKey = this.projectKey();

            this.info = await this._state.cardInfo(projectKey);
        });
    }
}
